module.exports = __webpack_public_path__ + "static/media/placeImageHere.8a86af8d.png";